import {needAuth} from "../instance/Instance";
import {encodeQueryData, getPages} from "../../components/commonmethod/CommonMethod";


async function getAsset(id) {
    console.log(">>> api : 자산 단건 조회")
    return  await needAuth.get('/assets/'+ id);
}

async function getAssets(search, pageable) {
    pageable.sort = [pageable.sort, "id"]
    try{
        const res = await needAuth.post('/assets?'+getPages(pageable),search);
        return  res;
    }catch (error){
        return error;
    }
}
async function getAssetsNoPages(search) {
    try{
        const res = await needAuth.post('/assets/nps' ,search);
        return  res;
    }catch (error){
        return error;
    }
}
async function getAssetsLifeCycle(search, pageable) {
    pageable.sort = [pageable.sort, "id"]
    try{
        const res = await needAuth.post('/assets/life-cycle?'+getPages(pageable),search);
        return  res;
    }catch (error){
        return error;
    }
}

async function getAssetsDispose(search, pageable) {
    pageable.sort = [pageable.sort, "id"]
    try{
        const res = await needAuth.post('/assets/dispose?'+getPages(pageable),search);
        return  res;
    }catch (error){
        return error;
    }
}

async function copyAsset(id) {
    try{
        const res = await needAuth.get(`/assets/copy/${id}`);
        return  res;
    }catch (error){
        return error;
    }
}

async function getAssetMaintenanceCompanies(search, pageable) {
    pageable.sort = [pageable.sort, "id"]
    try{
        const res = await needAuth.post('/assets/maintenance-assets?'+getPages(pageable),search);
        return  res;
    }catch (error){
        return error;
    }
}

async function getAssetsMybatis(search, pageable) {
    const newPage = {...pageable, sort:pageable.sort =="createdAt" ? pageable.sort = [pageable.sort, "id"] :pageable.sort = [pageable.sort]}
    try{
        const res = await needAuth.post('/assets/list?'+getPages(newPage),search);
        return  res;
    }catch (error){
        return error;
    }
}

async function getEosAssets(search, pageable) {
    pageable.sort = [pageable.sort, "id"]
    try{
        const res = await needAuth.post('/assets/eos?'+getPages(pageable),search);
        return  res;
    }catch (error){
        if (error?.response?.data) {
            return error.response;
        }
        return error;
    }
}

async function getAssetsByUser(type, user, pageable) {
    pageable.sort = [pageable.sort, "id"]
    try{
        const res = await needAuth.get(`/assets/${type}/${user.id}?`+getPages(pageable));
        return  res;
    }catch (error){
        return error;
    }
}

async function getAssetMemos(search, pageable) {
    pageable.sort = [pageable.sort, "id"]
    try{
        const res = await needAuth.post(`/assets/memo/asset?`+getPages(pageable), search);
        return  res;
    }catch (error){
        return error;
    }
}



async function createAsset(asset, images, files) {
    console.log(">>> api : 자산 등록")
    const formData = new FormData();
    images.forEach((image, index) => {
        formData.append(`images`, image);
    });
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });
    formData.append(
        "assetRequestDto",
        new Blob([JSON.stringify(asset)], { type: "application/json" })
    );
    try{
        return  await needAuth.post(
            '/assets/create',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
    }catch (error){
        return error;
    }
}


async function deleteAssets(data) {
    const queryString = `id=${data.join(',')}`;
    try {
        return await needAuth.delete(`/assets?${queryString}`);
    } catch (error) {
        return error;
    }
}



async function update(id, assetRequestDto, images = [], files = []) {
    const formData = new FormData();
    images.forEach((image) => {
        formData.append("images", image);
    });
    files.forEach((file) => {
        formData.append("files", file);
    });
    formData.append(
        "assetRequestDto",
        new Blob([JSON.stringify(assetRequestDto)], {type: "application/json"})
    );
    try {
        return await needAuth.put(`/assets/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    } catch (error) {
        return error;
    }
}

async function updateAsset(data) {
    try {
        return await needAuth.put(`/assets/single`, data);
    } catch (error) {
        return error;
    }
}

async function updateAssetLocations(data) {
    try {
        return await needAuth.patch(`/assets/locations`, data);
    } catch (error) {
        return error;
    }
}

async function getAssetMemo(id) {
    return  await needAuth.get('/assets/memo/'+ id);
}

async function createAssetMemo(dataMemo) {
    try {
        return await needAuth.post(`/assets/memo`, dataMemo);
    } catch (error) {
        return error;
    }
}
async function updateAssetMemo(dataMemo) {
    try {
        return await needAuth.put(`/assets/memo`, dataMemo);
    } catch (error) {
        return error;
    }
}

async function updateAssetField(data) {
    try {
        return await needAuth.put(`/assets/field`, data);
    } catch (error) {
        return error;
    }
}
async function updateAssetCustomCode(data) {
    try {
        return await needAuth.put(`/assets/customcode`, data);
    } catch (error) {
        throw error;  // 에러가 발생하면 throw
    }
}


async function updateAssetCustomString(data) {
    try {
        return await needAuth.put(`/assets/customcode/string`, data);
    } catch (error) {
        return error;
    }
}

export async function handleUsers(data) {
    try {
        return await needAuth.put(`/assets/users`, data);
    } catch (error) {
        return error;
    }
}

async function getAssetsNotUsed(search, pageable) {
    console.log(">> 감가상각관리 미사용 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/assets/unregistered-depreciation?'+pageStr,search);
    }catch (error){
        return error;
    }
}


async function getAssetsByRentalAsset(search, pageable) {
    pageable.sort = [pageable.sort, "id"]
    try{
        return  await needAuth.post(`/assets/rentalAsset?${getPages(pageable)}`, search);
    }catch (error){
        return error;
    }
}

async function getCommonColumns() {
    try {
        const res =await needAuth.get(`/assets/header/common`);
        return  res;
    } catch (error) {
        return error;
    }
}
async function getCommonStringColumns() {
    try {
        const res =await needAuth.get(`/assets/header/common-string`);
        return  res;
    } catch (error) {
        return error;
    }
}

async function assetNameDuplicate(name) {
    try {
        return await needAuth.get('/assets/duplicate/'+ name)
    }catch (error){
        return error;
    }
}

export {
    getAsset,
    getAssetsMybatis,
    getAssets,
    getAssetsNoPages,
    createAsset,
    update,
    updateAsset,
    updateAssetLocations,
    updateAssetField,
    getAssetsNotUsed,
    updateAssetCustomCode,
    deleteAssets,
    getAssetMemo,
    createAssetMemo,
    updateAssetMemo,
    getAssetsByRentalAsset,
    getAssetsByUser,
    updateAssetCustomString,
    getCommonColumns,
    getCommonStringColumns,
    getAssetMemos,
    getAssetsLifeCycle,
    getEosAssets,
    getAssetsDispose,
    getAssetMaintenanceCompanies,
    copyAsset,
    assetNameDuplicate
};